// @ts-nocheck
import * as React from "react";

const CartCheckmarkFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M8.56 19.44a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12Zm10 0a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12ZM5 4a1 1 0 0 1 1 .74L6.58 7h4.44a6.5 6.5 0 0 0 8.813 5.567L17.89 16.45A1 1 0 0 1 17 17H8a1 1 0 0 1-1-.74L4.24 6H3a1 1 0 1 1 0-2h2Zm12.503-2.65.22.005a5.15 5.15 0 0 1 4.927 5.148l-.005.22a5.15 5.15 0 1 1-5.363-5.368l.221-.005Zm-.003 1.3a3.85 3.85 0 0 0-.004 7.7l.196-.005a3.85 3.85 0 0 0 3.658-3.841l-.005-.196A3.85 3.85 0 0 0 17.5 2.65Zm2.141 1.83a.653.653 0 0 1 .123.916l-2.285 3a.655.655 0 0 1-.527.253l-.105-.01a.65.65 0 0 1-.395-.237l-1.223-1.566-.056-.087a.65.65 0 0 1 1.09-.7l.695.899 1.777-2.35.07-.08a.653.653 0 0 1 .836-.037Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CartCheckmarkFill);
